import type { ProductHoldings, Product } from '@accounts/domain';

/**
 * What each product holds, as lines for a confirmation's consequence: "Conduict: 2 machines — stopped
 * now, deleted after the grace period (billed while it exists)". A product that could not be checked is
 * said, never dropped, because silence would read as "holds nothing" (ACC-06, ACC-08, ACC-14).
 */
export function lines(holdings: ProductHoldings[], products: Product[] | undefined, text: (key: string, values?: Record<string, string | number>) => string): string[] {
	const named = (id: string) => products?.find(product => product.id === id)?.name ?? id;
	return holdings.flatMap(entry => {
		if (entry.state === 'unavailable') return [text('holdings.unavailable', { product: named(entry.product) })];
		return entry.items.map(item => `${named(entry.product)}: ${item.label} — ${item.consequence}${item.billing ? ` (${text('holdings.billing')})` : ''}`);
	});
}
